import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IEnvironmentDetails } from "../../interfaces/environment-details";
import { IAddPeerForm } from "../../interfaces/add-peer-form";

@Component({
  selector: "app-add-peer-to-network",
  templateUrl: "./add-peer-to-network.component.html",
  styleUrls: ["./add-peer-to-network.component.sass"],
})

export class AddPeerToNetworkComponent implements OnInit {

  @Input() currentEnvironment: IEnvironmentDetails;
  @Input() peeringForm: FormGroup;
  @Input() environments: IEnvironmentDetails[];
  @Output() environmentSelected = new EventEmitter<string>();
  @Output() addPeerSubmitted = new EventEmitter<IAddPeerForm>();
  selectedEnv: IEnvironmentDetails;

  constructor() {

  }

  ngOnInit(): void { }

  selectEnvironment(environmentKey: string): void {
    this.environmentSelected.emit(environmentKey);
    this.selectedEnv = this.environments.find(env => env.name === environmentKey);
  }

  onSubmit(): void {
    if (this.peeringForm.valid) {
      this.addPeerSubmitted.emit(this.peeringForm.value);
    }
  }

}
